import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import propertyViewingsService from '../services/propertyViewingsService';

const PropertyViewingsKeepInformed = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [email, setEmail] = useState('');

  useEffect(() => {
    loadPropertyDetails();
  }, [propertyId]);

  const loadPropertyDetails = async () => {
    try {
      setLoading(true);
      const response = await propertyViewingsService.getPropertyDetails(propertyId);
      setProperty(response.data);
    } catch (error) {
      console.error('Error loading property details:', error);
      toast.error('Failed to load property details.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeepInformed = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter an email address.');
      return;
    }

    try {
      setSubmitting(true);
      await propertyViewingsService.keepInformed(propertyId, email);
      toast.success('Successfully subscribed to property updates.');
      navigate('/property_viewings');
    } catch (error) {
      console.error('Error subscribing to updates:', error);
      toast.error('Failed to subscribe to updates.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (!property) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3>Keep Informed</h3>
              </div>
              <div className="panel-body">
                <p>Property not found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3>Keep Informed</h3>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-6">
                  <h4>Property Information</h4>
                  <p><strong>Property:</strong> {property.name || 'N/A'}</p>
                  <p><strong>Postcode:</strong> {property.postcode || 'N/A'}</p>
                  <p><strong>Available Rooms:</strong> {property.available_rooms || 'N/A'}</p>
                </div>
                <div className="col-md-6">
                  <h4>Subscribe to Updates</h4>
                  <p>Enter your email address to receive notifications about new viewings for this property.</p>
                  <form onSubmit={handleKeepInformed}>
                    <div className="form-group">
                      <label htmlFor="email">Email Address:</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mt-3">
                      <button 
                        type="submit"
                        className="btn btn-primary me-2" 
                        disabled={submitting}
                      >
                        {submitting ? 'Subscribing...' : 'Subscribe'}
                      </button>
                      <button 
                        type="button"
                        className="btn btn-secondary" 
                        onClick={() => navigate('/property_viewings')}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyViewingsKeepInformed; 